import React, { useState } from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import { MdOutlineQuiz } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';

const FAQ = () => {
    const [isActive, setIsActive] = useState(false);
    const navigate = useNavigate();

    return (
        <div className='faqContainer'>
            <div className="accordion-title d-flex justify-content-between align-items-center" onClick={() => setIsActive(!isActive)}>

                <div className='faq-container d-flex'>
                    <div className='faq-icon-contaner'>
                        <MdOutlineQuiz size={20} color="#FFFFFF" />
                    </div>
                    <span className='faqTitle'>FAQs</span>
                </div>

                <div className="col-1 d-flex justify-content-end"><span className="row toggleBtn">{isActive ? <CgClose size={22} /> : <BsPlusLg />}</span></div>
            </div>
            {isActive && <div className="accordion-content subText">
                <div>
                    <ul className='termAndConditionPoints mt-4'>
                    <li>
                        <p class='FAQ-Question' style={{color: '#FFFFFF'}}>What is the Bitcoin Premier League?</p>
                        <p class='paragraph' style={{color: '#FFFFFF', opacity: 0.5}}>The Bitcoin Premier League is an exciting event where users can answer three simple quiz questions for a chance to win exciting rewards and bonuses. Additionally</p>
                    </li>
                        <a style={{ color: '#D1964A', textDecoration: 'none' }} onClick={() => { navigate('/faq') }} className='tAndc'>View more <FiChevronRight style={{width: '18px', height: '18px', color:'#D1964A'}} className='back-button-icon' /></a>
                    </ul>
                </div>
            </div>}
        </div>
    );
}

export default FAQ;
